import { PanelContainer } from '../../types';
import { NetworkState } from './DefaultPanelWrapper/NetworkState';
import { usePanelIdentity } from '../../common';
import { PanelContextProvider, useMakePanelContext } from './PanelContext';
import { PanelFooter } from './PanelContext/PanelFooter';
import {
  usePanelTitleAction,
  usePanelTitleDescription,
} from '../../panelsUtil/usePanelTitleAction';
import { useDashboardContext } from '../../dashboard/DashboardContext';

export const LandingPagePanelWrapper: PanelContainer = ({
  children,
  ...props
}) => {
  const { panelId, panelName, panelType } = usePanelIdentity();

  const { contextValue, title, ref, ...footerProps } =
    useMakePanelContext(props);

  const panelTitleAction = usePanelTitleAction();
  const panelTitleDescription = usePanelTitleDescription();

  const dashboard = useDashboardContext();

  if (dashboard.getPanel(panelId).props.hasRss)
    console.log(dashboard.getPanel(panelId).props);

  return (
    <PanelContextProvider value={contextValue}>
      <div
        className="panel__container"
        data-panelname={panelName}
        data-paneltype={panelType}
        data-panelid={panelId}
        ref={ref}
      >
        <div className="panel__header">
          <div className="panel__header__left">
            {props.showTitle && (
              <span className="panel__title">
                {panelTitleAction ? (
                  <a
                    title={panelTitleDescription}
                    className="panel__title__link"
                    href={panelTitleAction}
                  >
                    {title}
                  </a>
                ) : (
                  title
                )}
              </span>
            )}
            <NetworkState title={title} />
          </div>
        </div>
        <div className="panel__content">{children}</div>
        <PanelFooter isRefreshable={false} {...footerProps} />
      </div>
    </PanelContextProvider>
  );
};
